<template>
    <a-modal v-model="visible" :title="!!form.id ? '编辑权益' : '新增权益'" @ok="handleOk" :confirm-loading="confirmLoading"
        @cancel="handleCancel" :maskClosable="false" :keyboard="false" width="600px">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="会员权益名称" prop="name">
                <a-input type="textarea" :maxLength="500" v-model="form.name" disabled placeholder="请录入会员权益"
                    :auto-size="{ minRows: 2, maxRows: 10 }" />

                <div v-if="!form.id">快捷输入： <a-button style="margin-right: 8px;" size="small" v-for="v in tags"
                        @click="addTag(v)">{{ v.name
                        }}</a-button></div>
            </a-form-model-item>
            <a-form-model-item label="使用次数" prop="cishu" v-if="!form.id">
                <a-input-number v-model="form.cishu" :min="1" placeholder="请输入使用次数" /> <span
                    style="padding-left: 10px;">次（大于1会生成多条此权益）</span>
            </a-form-model-item>
            <a-form-model-item label="使用状态" prop="use_type">
                <a-radio-group v-model="form.use_type">
                    <a-radio value="1">未使用</a-radio>
                    <a-radio value="2">已使用</a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="使用时间" prop="use_time" v-if="form.use_type == 2">
                <a-date-picker show-time v-model="form.use_time" placeholder="请选择" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            tags: [],
            form: {
                id: void 0,
                customer_id: "",
                name: '',
                benefit_tag_id: "",
                cishu: 1,
                use_type: '1',
                use_time: undefined
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入会员权益名称",
                        trigger: "blur",
                    },
                ],
                use_type: [
                    {
                        required: true,
                        message: "请选择使用状态",
                        trigger: "blur",
                    },
                ],
                use_time: [
                    {
                        required: true,
                        message: "请选择使用时间",
                        trigger: "change",
                    },
                ],
            }
        }
    },
    methods: {
        addTag(v) {
            this.form.name = v.name
            this.form.benefit_tag_id = v.id
        },
        init({ customer_id, info }) {
            this.visible = true;
            this.form.customer_id = customer_id;
            if (info) {
                this.form = {
                    ...this.form,
                    ...JSON.parse(JSON.stringify(info))
                };
                this.form.use_type = '2'
            }
            this.gettag()
        },
        gettag() {
            this.$http({
                url: "/admin/customer/benefitTag",
                method: "get",
            }).then((res) => {
                this.tags = res.data
            });
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: this.form.id
                            ? "/admin/customer/writeOffCustomerBenefit"
                            : "/admin/customer/createCustomerBenefit",
                        method: "post",
                        data: {
                            ...this.form,
                        },
                    })
                        .then(() => {
                            this.$message.success(
                                this.form.member_id ? "修改成功" : "创建成功"
                            );
                            this.handleCancel();
                            this.$emit("ok");
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            })
        },
        handleCancel() {
            this.visible = false;
            this.$refs["ruleForm"].resetFields();
            this.form.id = void 0;
            this.confirmLoading = false;
        },
    }
}
</script>